import type { StyledComponent } from "@emotion/styled";
import styled from "@emotion/styled";
import { notEmpty } from "@product/scmp-sdk";
import type { FunctionComponent } from "react";

import type { ContentSchemaRenderProps } from "~/components/content/content-schema-render";
import type { ExtraProps as YoutubeExtraProps } from "~/components/content/content-schema-render/iframe/scmp-youtube";
import { SCMPYoutube } from "~/components/content/content-schema-render/iframe/scmp-youtube";

import { IframeType } from "./enums";
import { GenericIframe } from "./generic-iframe";
import { isScmpYoutubeVideo } from "./helpers";

export type Props = {
  "data-video-source"?: string;
  "data-youtube-id"?: string;
  src?: string;
} & YoutubeExtraProps &
  ContentSchemaRenderProps;

const Component: FunctionComponent<Props> = ({ src, ...attribs }) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const renderMap: Record<string, StyledComponent<any, any>> = {
    [IframeType.GenericIframe]: GenericIframe,
    [IframeType.SCMPYouTubeVideo]: SCMPYoutube,
  };

  if (!notEmpty(src)) return null;
  let renderType: IframeType = IframeType.GenericIframe;
  if (isScmpYoutubeVideo(attribs)) renderType = IframeType.SCMPYouTubeVideo;
  // TODO: check if it's quiz
  const Component = renderMap[renderType];

  return <Component {...{ ...attribs, src }} />;
};

Component.displayName = "Iframe";
export const Iframe = styled(Component)``;
